/* tslint:disable */
/* eslint-disable */
/**
 * Akfen İnşaat Avocet Webapi
 * Akfen İnşaat Data Web Servis
 *
 * The version of the OpenAPI document: v1
 * Contact: support@rasyonet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CardField
 */
export interface CardField {
    /**
     * 
     * @type {string}
     * @memberof CardField
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardField
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CardField
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardField
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContentType = {
    Nav: 'Nav',
    FreeFloat: 'FreeFloat',
    Portfolio: 'Portfolio',
    Performace: 'Performace'
} as const;

export type ContentType = typeof ContentType[keyof typeof ContentType];


/**
 * 
 * @export
 * @interface FValue
 */
export interface FValue {
    /**
     * 
     * @type {string}
     * @memberof FValue
     */
    'type'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof FValue
     */
    'value'?: any | null;
}
/**
 * 
 * @export
 * @interface FinancialValue
 */
export interface FinancialValue {
    /**
     * 
     * @type {string}
     * @memberof FinancialValue
     */
    'name'?: string | null;
    /**
     * 
     * @type {FValue}
     * @memberof FinancialValue
     */
    'value'?: FValue;
    /**
     * 
     * @type {number}
     * @memberof FinancialValue
     */
    'quarter'?: number;
    /**
     * 
     * @type {string}
     * @memberof FinancialValue
     */
    'formattedQuarter'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FinancialValue
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface IndexWeightRow
 */
export interface IndexWeightRow {
    /**
     * 
     * @type {string}
     * @memberof IndexWeightRow
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IndexWeightRow
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface NavPoint
 */
export interface NavPoint {
    /**
     * 
     * @type {number}
     * @memberof NavPoint
     */
    'quarter'?: number;
    /**
     * 
     * @type {number}
     * @memberof NavPoint
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface NewsDetail
 */
export interface NewsDetail {
    /**
     * 
     * @type {string}
     * @memberof NewsDetail
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsDetail
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface NewsRow
 */
export interface NewsRow {
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'header'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PriceChartPeriod = {
    OneWeek: 'OneWeek',
    OneMonth: 'OneMonth',
    ThreeMonth: 'ThreeMonth',
    SixMonth: 'SixMonth',
    OneYear: 'OneYear',
    TwoYear: 'TwoYear',
    ThreeYear: 'ThreeYear',
    FiveYear: 'FiveYear'
} as const;

export type PriceChartPeriod = typeof PriceChartPeriod[keyof typeof PriceChartPeriod];


/**
 * 
 * @export
 * @interface PricePoint
 */
export interface PricePoint {
    /**
     * 
     * @type {string}
     * @memberof PricePoint
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof PricePoint
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface QarterInfo
 */
export interface QarterInfo {
    /**
     * 
     * @type {number}
     * @memberof QarterInfo
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof QarterInfo
     */
    'name'?: string | null;
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [password] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationGet: async (password?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [password] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationGet(password?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationGet(password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [password] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationGet(password?: string, options?: any): AxiosPromise<string> {
            return localVarFp.authenticationGet(password, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @param {string} [password] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationGet(password?: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationGet(password, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ContentType} [fileContentType] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadPost: async (fileContentType?: ContentType, token?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/file/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (fileContentType !== undefined) {
                localVarQueryParameter['fileContentType'] = fileContentType;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ContentType} [fileContentType] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadPost(fileContentType?: ContentType, token?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUploadPost(fileContentType, token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * 
         * @param {ContentType} [fileContentType] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadPost(fileContentType?: ContentType, token?: string, options?: any): AxiosPromise<void> {
            return localVarFp.fileUploadPost(fileContentType, token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @param {ContentType} [fileContentType] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileUploadPost(fileContentType?: ContentType, token?: string, options?: AxiosRequestConfig) {
        return FileApiFp(this.configuration).fileUploadPost(fileContentType, token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialApi - axios parameter creator
 * @export
 */
export const FinancialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financialQuartersGet: async (culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/financial/quarters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {number} [quarter] 
         * @param {string} [currency] 
         * @param {string} [culture] 
         * @param {boolean} [onlyYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financialValuesGet: async (symbolEntityId?: string, quarter?: number, currency?: string, culture?: string, onlyYear?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/financial/values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (quarter !== undefined) {
                localVarQueryParameter['quarter'] = quarter;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (onlyYear !== undefined) {
                localVarQueryParameter['onlyYear'] = onlyYear;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialApi - functional programming interface
 * @export
 */
export const FinancialApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financialQuartersGet(culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QarterInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financialQuartersGet(culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {number} [quarter] 
         * @param {string} [currency] 
         * @param {string} [culture] 
         * @param {boolean} [onlyYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async financialValuesGet(symbolEntityId?: string, quarter?: number, currency?: string, culture?: string, onlyYear?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.financialValuesGet(symbolEntityId, quarter, currency, culture, onlyYear, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FinancialApi - factory interface
 * @export
 */
export const FinancialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financialQuartersGet(culture?: string, options?: any): AxiosPromise<Array<QarterInfo>> {
            return localVarFp.financialQuartersGet(culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {number} [quarter] 
         * @param {string} [currency] 
         * @param {string} [culture] 
         * @param {boolean} [onlyYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        financialValuesGet(symbolEntityId?: string, quarter?: number, currency?: string, culture?: string, onlyYear?: boolean, options?: any): AxiosPromise<Array<FinancialValue>> {
            return localVarFp.financialValuesGet(symbolEntityId, quarter, currency, culture, onlyYear, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialApi - object-oriented interface
 * @export
 * @class FinancialApi
 * @extends {BaseAPI}
 */
export class FinancialApi extends BaseAPI {
    /**
     * 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialApi
     */
    public financialQuartersGet(culture?: string, options?: AxiosRequestConfig) {
        return FinancialApiFp(this.configuration).financialQuartersGet(culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {number} [quarter] 
     * @param {string} [currency] 
     * @param {string} [culture] 
     * @param {boolean} [onlyYear] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialApi
     */
    public financialValuesGet(symbolEntityId?: string, quarter?: number, currency?: string, culture?: string, onlyYear?: boolean, options?: AxiosRequestConfig) {
        return FinancialApiFp(this.configuration).financialValuesGet(symbolEntityId, quarter, currency, culture, onlyYear, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SnaphotApi - axios parameter creator
 * @export
 */
export const SnaphotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotCardFieldsGet: async (symbolEntityId?: string, cultureCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/card-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotIndexWeightGet: async (symbolEntityId?: string, cultureCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/index-weight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotMkknewsDetailGet: async (newsId?: string, cultureCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/mkknews-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (newsId !== undefined) {
                localVarQueryParameter['newsId'] = newsId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotMkknewsGet: async (cultureCode?: string, firstDate?: string, lastdate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/mkknews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }

            if (firstDate !== undefined) {
                localVarQueryParameter['firstDate'] = (firstDate as any instanceof Date) ?
                    (firstDate as any).toISOString() :
                    firstDate;
            }

            if (lastdate !== undefined) {
                localVarQueryParameter['lastdate'] = (lastdate as any instanceof Date) ?
                    (lastdate as any).toISOString() :
                    lastdate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNavChartGet: async (symbolEntityId?: string, currency?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/nav-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsDetailGet: async (newsId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/news-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (newsId !== undefined) {
                localVarQueryParameter['newsId'] = newsId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsGet: async (symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }

            if (firstDate !== undefined) {
                localVarQueryParameter['firstDate'] = (firstDate as any instanceof Date) ?
                    (firstDate as any).toISOString() :
                    firstDate;
            }

            if (lastdate !== undefined) {
                localVarQueryParameter['lastdate'] = (lastdate as any instanceof Date) ?
                    (lastdate as any).toISOString() :
                    lastdate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotPriceChartGet: async (symbolEntityId?: string, period?: PriceChartPeriod, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/price-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SnaphotApi - functional programming interface
 * @export
 */
export const SnaphotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SnaphotApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CardField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotCardFieldsGet(symbolEntityId, cultureCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotIndexWeightGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IndexWeightRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotIndexWeightGet(symbolEntityId, cultureCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotMkknewsDetailGet(newsId?: string, cultureCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotMkknewsDetailGet(newsId, cultureCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotMkknewsGet(cultureCode?: string, firstDate?: string, lastdate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotMkknewsGet(cultureCode, firstDate, lastdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotNavChartGet(symbolEntityId?: string, currency?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NavPoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotNavChartGet(symbolEntityId, currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotNewsDetailGet(newsId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotNewsDetailGet(newsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotNewsGet(symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotNewsGet(symbolEntityId, cultureCode, firstDate, lastdate, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotPriceChartGet(symbolEntityId?: string, period?: PriceChartPeriod, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PricePoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotPriceChartGet(symbolEntityId, period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SnaphotApi - factory interface
 * @export
 */
export const SnaphotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SnaphotApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: any): AxiosPromise<Array<CardField>> {
            return localVarFp.snaphotCardFieldsGet(symbolEntityId, cultureCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotIndexWeightGet(symbolEntityId?: string, cultureCode?: string, options?: any): AxiosPromise<Array<IndexWeightRow>> {
            return localVarFp.snaphotIndexWeightGet(symbolEntityId, cultureCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotMkknewsDetailGet(newsId?: string, cultureCode?: string, options?: any): AxiosPromise<NewsDetail> {
            return localVarFp.snaphotMkknewsDetailGet(newsId, cultureCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotMkknewsGet(cultureCode?: string, firstDate?: string, lastdate?: string, options?: any): AxiosPromise<Array<NewsRow>> {
            return localVarFp.snaphotMkknewsGet(cultureCode, firstDate, lastdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNavChartGet(symbolEntityId?: string, currency?: string, options?: any): AxiosPromise<Array<NavPoint>> {
            return localVarFp.snaphotNavChartGet(symbolEntityId, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsDetailGet(newsId?: string, options?: any): AxiosPromise<NewsDetail> {
            return localVarFp.snaphotNewsDetailGet(newsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsGet(symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options?: any): AxiosPromise<Array<NewsRow>> {
            return localVarFp.snaphotNewsGet(symbolEntityId, cultureCode, firstDate, lastdate, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotPriceChartGet(symbolEntityId?: string, period?: PriceChartPeriod, options?: any): AxiosPromise<Array<PricePoint>> {
            return localVarFp.snaphotPriceChartGet(symbolEntityId, period, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SnaphotApi - object-oriented interface
 * @export
 * @class SnaphotApi
 * @extends {BaseAPI}
 */
export class SnaphotApi extends BaseAPI {
    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [cultureCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotCardFieldsGet(symbolEntityId, cultureCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [cultureCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotIndexWeightGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotIndexWeightGet(symbolEntityId, cultureCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [newsId] 
     * @param {string} [cultureCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotMkknewsDetailGet(newsId?: string, cultureCode?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotMkknewsDetailGet(newsId, cultureCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cultureCode] 
     * @param {string} [firstDate] 
     * @param {string} [lastdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotMkknewsGet(cultureCode?: string, firstDate?: string, lastdate?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotMkknewsGet(cultureCode, firstDate, lastdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [currency] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotNavChartGet(symbolEntityId?: string, currency?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotNavChartGet(symbolEntityId, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [newsId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotNewsDetailGet(newsId?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotNewsDetailGet(newsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [cultureCode] 
     * @param {string} [firstDate] 
     * @param {string} [lastdate] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotNewsGet(symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotNewsGet(symbolEntityId, cultureCode, firstDate, lastdate, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {PriceChartPeriod} [period] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotPriceChartGet(symbolEntityId?: string, period?: PriceChartPeriod, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotPriceChartGet(symbolEntityId, period, options).then((request) => request(this.axios, this.basePath));
    }
}



